jQuery(document).on('click', '.start_first_step', function(){
    jQuery('.screening_tabs').css('display', 'none');
    
    jQuery('div#screening_step_2').animate( { "opacity": "show", top:"100"} , 500 );
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
});

jQuery(document).on('click', '.cancel_all_steps', function(){
    jQuery('.screening_tabs').css('display', 'none');
    jQuery(this).parents('.flex-column').css('display', 'none');
    jQuery('div#screening_step_1').animate( { "opacity": "show", top:"100"} , 500 );
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');

    jQuery('input[type="checkbox"]:checkbox:checked').prop('checked', false);
    jQuery('input[type="radio"]:checked').prop('checked', false);
});

jQuery(document).on('click', '#third_step_back', function(){
    jQuery('.screening_tabs').css('display', 'none');
    
    jQuery('div#screening_step_2').animate( { "opacity": "show", top:"100"} , 500 );
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
});

jQuery(document).on('click', '#final_step_back', function(){
    jQuery('.screening_tabs').css('display', 'none');
    
    jQuery('div#screening_step_3').animate( { "opacity": "show", top:"100"} , 500 );
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
});


jQuery(document).on('click', '#second_step_screen, #second_step_else', function(){
    jQuery('#second_step_screening').val(jQuery(this).text());
    jQuery('div#screening_step_1, div#screening_step_2, div#screening_step_3 .flex-column:last').css('display', 'none');
    jQuery('div#screening_step_3').css('display', 'block');
    jQuery('div#screening_step_3 .flex-column:first').animate( { "opacity": "show", top:"0"} , 500 );

    if(jQuery(this).text()=='Use For Myself'){
      jQuery('.change-text').text('you');
      jQuery('.change-text.same-i').text('I');
      jQuery('.change-text.same-you').text('you');
      jQuery('.change-text.were').text('was');
      jQuery('input#f-option').siblings('label').find('span.change-text.capital').text('I\'m');
      jQuery('.change-text.are').text('you\'re');
      jQuery('.change-text.your').text('your');
      jQuery('.change-text.theme').text('them');
    }else{
      jQuery('.selection-share').removeClass('selection');
      jQuery('.change-text').text('they');
      jQuery('.change-text.same-i').text('they');
      jQuery('input#f-option').siblings('label').find('span.change-text.capital').text('They\'re');
      jQuery('.change-text.were').text('were');
      jQuery('.change-text.their').text('their');
      jQuery('.change-text.there').text('they\'re');
      jQuery('.change-text.theme').text('them');
    }
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
});


jQuery(document).on('change', 'input[type="radio"], input[type="checkbox"]', function () {
  if(jQuery(this).parents('.flex-column').find('input[type="radio"]:checked').length>=1){
    if (jQuery(this).is(':checked')) {
      jQuery(this).parents('.detail').find('a#third_step_screen').css('pointer-events', 'all');
      jQuery(this).parents('.detail').find('a#third_step_screen').removeAttr('disabled');
    }else {
      jQuery('a#third_step_screen').css('pointer-events', 'none');
      jQuery('a#third_step_screen').attr('disabled', 'disabled');
    }
  }else if(jQuery(this).parents('.flex-column').find('input[type="checkbox"]:checkbox:checked').length>=1){
    console.log('checkbox');
    jQuery(this).parents('.detail').find('a#third_step_screen').css('pointer-events', 'all');
    jQuery(this).parents('.detail').find('a#third_step_screen').removeAttr('disabled');
  }else{
    console.log('else');
    jQuery('a#third_step_screen').css('pointer-events', 'none');
    jQuery('a#third_step_screen').attr('disabled', 'disabled');
  }
});


jQuery(document).on('change', '.labeled-dropdown-select', function () {
    var leng = jQuery(this).val();
    if(leng){
        jQuery(this).parents('.detail').find('a#third_step_screen').css('pointer-events', 'all');
        jQuery(this).parents('.detail').find('a#third_step_screen').removeAttr('disabled');
    }else {
      jQuery('a#third_step_screen').css('pointer-events', 'none');
      jQuery('a#third_step_screen').attr('disabled', 'disabled');
    }
});


jQuery(document).on('click', '#emergency_step_screen', function(){
  if(jQuery('input[name="selectors"]:checked').val()!='' && jQuery('input[name="selectors"]:checked').val()!=undefined){
    if(jQuery('input[name="selectors"]:checked').val()==0){
      jQuery('.screening_tabs').css('display', 'none');
      jQuery('div#screening_step_4').animate( { "opacity": "show", top:"100"} , 500 );
    }else if(jQuery('input[name="selectors"]:checked').val()==1){
      jQuery(this).parents('.flex-column').css('display', 'none');
      jQuery(this).parents('.flex-column').next('.selection').animate( { "opacity": "show", top:"0"} , 500 );
    }
    
    jQuery('html,body').animate({
      scrollTop: jQuery('.page-container-content').offset().top-90
    }, 'slow');
  }else{
    //
  }
});


jQuery(document).on('click', '#final_step_screen', function(){
    var second_step_screening   = jQuery('#second_step_screening').val();
    var third_step_screening  = jQuery('input[name="selector"]:checked').val();

    jQuery('.screening_tabs').css('display', 'none');
    jQuery('div#screening_step_1').animate( { "opacity": "show", top:"100"} , 500 );
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
    
    jQuery('input[type="checkbox"]:checkbox:checked').prop('checked', false);
    jQuery('input[type="radio"]:checked').prop('checked', false);
});


jQuery(document).on('click', '.first_step_leanmore', function(){
    jQuery('.screening_tabs').css('display', 'none');
    
    jQuery('div#covid_19_detail_1').animate( { "opacity": "show", top:"100"} , 500 );
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
});


jQuery(document).on('click', '.second_step_leanmore', function(){
    jQuery('.screening_tabs').css('display', 'none');
    
    jQuery('div#covid_19_detail_2').animate( { "opacity": "show", top:"100"} , 500 );
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
});


jQuery(document).on('click', '.third_step_leanmore', function(){
    jQuery('.screening_tabs').css('display', 'none');
    
    jQuery('div#covid_19_detail_3').animate( { "opacity": "show", top:"100"} , 500 );
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
});


jQuery(document).on('click', '.fourth_step_leanmore', function(){
    jQuery('.screening_tabs').css('display', 'none');
    
    jQuery('div#covid_19_detail_4').animate( { "opacity": "show", top:"100"} , 500 );
  
    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
});


jQuery(document).on('change', '#choose_state', function(){
  var web_url     = jQuery("#choose_state option:selected").attr("data-url");
  var web_domain  = jQuery("#choose_state option:selected").attr("data-name");
  var web_name    = jQuery("#choose_state option:selected").text();
  var web_val     = jQuery("#choose_state option:selected").val();
  
  if(web_val!='' && web_val!=undefined){
  jQuery('#state_text_changings p').html('Information available at <a href="'+web_url+'" target="_blank">'+web_domain+'</a>');
      jQuery('#state_text_changings').prev('.top-title.before').find('h2').text(web_name);
  }else{ 
      jQuery('#state_text_changings p').text('Choose a state to see guidance from the health department.');
    jQuery('#state_text_changings').prev('.top-title.before').find('h2').text('STATE INFORMATION'); 
  }
});



jQuery(document).on('click', '.next-button', function(){
  if(jQuery('input[name="selector1"]:checked').val()!='' && jQuery('input[name="selector1"]:checked').val()!=undefined){
    if(jQuery('input[name="selector1"]:checked').val()==2){
        jQuery('div#screening_step_3 .full_row').css('display', 'none');
      jQuery('div#screening_step_3 .under_18_done').animate( { "opacity": "show", top:"0"} , 500 );
    }else if(jQuery('input[name="selector1"]:checked').val()==3){
        jQuery('.screening_tabs').css('display', 'none'); 
        jQuery('#screening_step_3 #age-tab').css('display', 'none');
        jQuery('div#screening_step_3').animate( { "opacity": "show", top:"100"} , 500 );
      jQuery('div#screening_step_3 #select-age').animate( { "opacity": "show", top:"0"} , 500 );
    }

    jQuery('html,body').animate({
      scrollTop: jQuery(".page-container-content").offset().top
    }, 'slow');
  }else{
    //
  }
});


/************************************************************/
/************************************************************/

function resopnsesList($skip, $share='notshare') {

  var changing_text = 'You';
  if(jQuery.trim(jQuery('#second_step_screening').val())==jQuery.trim('Use For Myself')){
    changing_text = 'You';
  }else{
    changing_text = 'They';
  }

  var agging = jQuery('input[name="agging"]:checked').val();
  var agging_text;
  if(agging){
    agging_text = changing_text+' are '+agging+ ' years old';
  }

  var symptoms = jQuery('#check-08:checked').val();
  var symptoms_text;
  if(symptoms){
      symptoms_text = changing_text+' are experiencing no symptoms';
  }else{
      symptoms_text = changing_text+' are experiencing symptoms';
  }

  var condition = jQuery('#check-18:checked').val();
  var condition_text;
  if(condition=='I do not have any of these'){
      condition_text = changing_text+' do not have relevant conditions';
  }else{
      condition_text = changing_text+' have relevant conditions';
  }

  var traveled = jQuery('input[name="traveled"]:checked').val();
  var traveled_text;
  if(traveled=='They have not traveled internationally'){
      traveled_text = changing_text+' have not traveled internationally';
  }else{
      traveled_text = changing_text+' have traveled internationally';
  }

  var exposure = jQuery('input[name="exposure"]:checkbox:checked').length;
  var exposure_no_expos = jQuery('input[name="exposure_no_expos"]:checkbox:checked').length;
  var donnotknow = jQuery('input[name="donnotknow"]:checkbox:checked').length;
  var exposure_text;
  if(exposure>=1){
    exposure_text = changing_text+' have been exposed to others who have COVID‑19';
  }else if(exposure_no_expos==1){
    exposure_text = changing_text+' have not been exposed to others who have COVID‑19';
  }else if(donnotknow==1){
    exposure_text = changing_text+'’re not sure if you’ve been exposed to others who have COVID‑19';
  }

  var care_facility = jQuery('input[name="care-facility"]:checked').val();
  var care_facility_text;
  if(care_facility=='They don’t live in a long-term care facility'){
    care_facility_text = changing_text+' don’t live in a long-term care facility';
  }else{
    care_facility_text = changing_text+' live in a long-term care facility';
  }

  var medical_facility = jQuery('input[name="medical_facility"]:checked').val();
  var donnotknow_med = jQuery('input[name="donnotknow_med"]:checked').val();
  var medical_facility_text;
  if(donnotknow_med=='They don’t work or plan to work in a medical facility'){
      medical_facility_text = changing_text+' don’t work or plan to work in a medical facility';
  }else{
    medical_facility_text = changing_text+' work or plan to work in a medical facility';
  }

  if($skip=='notskip'){
    var selected_state = jQuery('.labeled-dropdown-select').val();
    var selected_state_text='';
    if(selected_state){
        selected_state_text = 'State selected: '+jQuery(".labeled-dropdown-select option:selected").text();
    }
  }else{
    selected_state_text = '';
  }

  var medical_close_contact = jQuery('input[name="medical_close_contact"]:checked').val();
  var equipment = jQuery('input[name="equipment"]:checked').val();
  var medical_close_contact1;
  var medical_close_contact2;
  if(medical_close_contact=='Yes' && equipment=='Yes'){
    medical_close_contact1  = 'While working in a medical facility, '+changing_text+' had close contact with others who have COVID‑19';
    medical_close_contact2  = changing_text+' were always wearing PPE when in close contact with others who have COVID‑19';
  }else if(medical_close_contact=='Yes' && equipment=='No'){
    medical_close_contact1  = 'While working in a medical facility, '+changing_text+' had close contact with others who have COVID‑19';
    medical_close_contact2  = changing_text+' were not always wearing PPE when in close contact with others who have COVID‑19';
  }else if(medical_close_contact=='No' && equipment==undefined){
    medical_close_contact1  = 'While working in a medical facility, '+changing_text+' did not have close contact with others who have COVID‑19';
    medical_close_contact2  = '';
  }else{
    medical_close_contact1 = '';
    medical_close_contact2 = '';
  }

  if($share=='share'){
    $share = 'Your anonymous answers will be used to improve this tool and better understand the spread of COVID‑19';
  }else{
    $share = '';
  }

  var final_response = '';
  final_response+= '<li>'+agging_text+'</li>';
  final_response+= '<li>'+symptoms_text+'</li>';
  final_response+= '<li>'+condition_text+'</li>';
  final_response+= '<li>'+traveled_text+'</li>';
  final_response+= '<li>'+exposure_text+'</li>';
  final_response+= '<li>'+care_facility_text+'</li>';
  final_response+= '<li>'+medical_facility_text+'</li>';
  final_response+= '<li>'+selected_state_text+'</li>';
  final_response+= '<li>'+medical_close_contact1+'</li>';
  final_response+= '<li>'+medical_close_contact2+'</li>';
  final_response+= '<li>'+$share+'</li>';

  return final_response;
}


function getCurrentDate() {
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var now = new Date();
  var month = monthNames[now.getMonth()]
  var date = now.getDate()
  var year = now.getFullYear()
  var time = now.toLocaleString([], { hour: '2-digit', minute: '2-digit' });

  return 'Completed '+month+' '+date+', '+year+', '+time;
}

function showNextSteps() {
  var no_symptoms_sym           = jQuery('input[name="symptoms_sym"]:checked').val();
  var symptoms                  = jQuery('input[name="symptoms"]:checked').val();
  var symptoms_len              = jQuery('input[name="symptoms"]:checkbox:checked').length;
  var apply_selector            = jQuery('input[name="selector"]:checked').val();
  var apply_len                 = jQuery('input[name="selector"]:checkbox:checked').length;
  var no_noneofabove            = jQuery('input[name="noneofabove"]:checked').val();
  var traveled                  = jQuery('input[name="traveled"]:checked').val();
  var no_donnotknow             = jQuery('input[name="donnotknow"]:checked').val();
  var no_exposure               = jQuery('input[name="exposure"]:checked').val();
  var exposure_no_expos         = jQuery('input[name="exposure_no_expos"]:checked').val();
  var exposure_len              = jQuery('input[name="exposure"]:checkbox:checked').length;
  var no_care_facility          = jQuery('input[name="care-facility"]:checked').val();
  var no_donnotknow_med         = jQuery('input[name="donnotknow_med"]:checked').val();
  var no_medical_close_contact  = jQuery('input[name="medical_close_contact"]:checked').val();
  var no_equipment              = jQuery('input[name="equipment"]:checked').val();
  var medical_facility          = jQuery('input[name="medical_facility"]:checked').val();
  var no_medical_facility       = jQuery('input[name="medical_facility"]:checkbox:checked').length;
  var donnotknow_med            = jQuery('input[name="donnotknow_med"]:checkbox:checked').length;
  var donnotknow                = jQuery('input[name="donnotknow"]:checkbox:checked').length;
  var exposure_no_len           = jQuery('input[name="exposure_no_expos"]:checkbox:checked').length;

  var changing_text = 'your';
    changing_text2 = 'you';
  if(jQuery.trim(jQuery('#second_step_screening').val())==jQuery.trim('Use For Myself')){
    changing_text = 'your';
    changing_text2 = 'you';
  }else{
    changing_text = 'Their';
    changing_text2 = 'they';
  }



/*Similar steps conditions*/
  var step_1to6_1 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact=='Yes' && no_equipment=='Yes';

  var step_1to6_2 = symptoms_len <=7 && apply_len <= 9 && symptoms_len !=0 && apply_len != 0 && traveled=='They have traveled internationally' && 
    exposure_len==3 && no_care_facility=='They live in a long-term care facility' && medical_facility=='They have worked in a hospital or other facility in the past 14 days' && 
    ((no_medical_close_contact=='Yes' && no_equipment=='Yes') || (no_medical_close_contact=='Yes' && no_equipment=='No') || (no_medical_close_contact=='No' && no_equipment==undefined) );

  var step_1to6_3 = symptoms_len <=7 && apply_len <= 9 && symptoms_len !=0 && apply_len != 0 && traveled=='They have traveled internationally' && 
    no_exposure=='They live with someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact==undefined && no_equipment==undefined;

  var step_1to6_4 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact=='Yes' && no_equipment=='No';

  var step_1to6_5 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact=='No' && no_equipment==undefined;

  var step_1to6_6 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    exposure_no_expos=='They’ve had no exposure' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact==undefined && no_equipment==undefined;

  var step_1to6_7 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    exposure_no_expos=='They’ve had no exposure' && no_care_facility=='They live in a long-term care facility' && 
    donnotknow_med==1 && no_medical_close_contact==undefined && no_equipment==undefined;

  var step_1to6_8 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    donnotknow==1 && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact==undefined && no_equipment==undefined;

  var step_1to6_9 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    no_exposure=='They’ve been near someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact==undefined && no_equipment==undefined;

  var covid1 = jQuery('input#check-21:checked').val();
  var covid2 = jQuery('input#check-22:checked').val();
  var covid3 = jQuery('input#check-23:checked').val();

  var step_1to6_10 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    covid1!=undefined && covid2!=undefined && covid3!=undefined && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact=='Yes' && no_equipment=='Yes';

  var step_1to6_11 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    covid1!=undefined && no_care_facility=='They live in a long-term care facility' && medical_facility=='They have worked in a hospital or other facility in the past 14 days' && 
    no_medical_close_contact=='Yes' && no_equipment=='Yes';


/*****************************/
  
  var health_provider = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They don’t live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider2 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They don’t live in a long-term care facility' && 
    donnotknow_med==1 && no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider3 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    donnotknow_med==1 && no_care_facility=='They don’t live in a long-term care facility' && medical_facility=='They have worked in a hospital or other facility in the past 14 days' &&
    no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider4 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    donnotknow_med==1 && no_care_facility=='They don’t live in a long-term care facility' && donnotknow_med==1 &&
    no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider5 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    donnotknow==1 && no_care_facility=='They don’t live in a long-term care facility' && medical_facility=='They have worked in a hospital or other facility in the past 14 days' &&
    no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider6 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    donnotknow==1 && no_care_facility=='They don’t live in a long-term care facility' && donnotknow_med==1 &&
    no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider7 = symptoms_len <=7 && apply_len <= 9 && symptoms_len !=0 && apply_len != 0 && traveled=='They have not traveled internationally' && 
    donnotknow==1 && no_care_facility=='They don’t live in a long-term care facility' && donnotknow_med==1 &&
    no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider8 = symptoms_len <=7 && apply_len <= 9 && symptoms_len !=0 && apply_len != 0 && traveled=='They have not traveled internationally' && 
    exposure_no_len==1 && no_care_facility=='They don’t live in a long-term care facility' && donnotknow_med==1 &&
    no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider9 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    exposure_no_len==1 && no_care_facility=='They don’t live in a long-term care facility' && medical_facility=='They have worked in a hospital or other facility in the past 14 days' &&
    no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider10 = symptoms !='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    donnotknow==1 && no_care_facility=='They don’t live in a long-term care facility' && medical_facility=='They don’t work or plan to work in a medical facility' &&
    no_medical_close_contact==undefined && no_equipment==undefined;

  var health_provider11 = symptoms_len <=7 && apply_len <= 9 && symptoms_len !=0 && apply_len != 0 && traveled=='They have traveled internationally' && 
    (no_exposure=='They’ve had close contact with someone who has COVID‑19' || no_exposure=='They plan to work in a hospital or other facility in the next 14 days') && no_care_facility=='They don’t live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && ((no_medical_close_contact=='Yes' && no_equipment=='Yes') || (no_medical_close_contact=='Yes' && no_equipment=='No') || (no_medical_close_contact=='No' && no_equipment==undefined) );

  var health_provider12 = symptoms_len <=7 && apply_len <= 9 && symptoms_len !=0 && apply_len != 0 && (traveled=='They have traveled internationally' || traveled=='They have not traveled internationally') && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They don’t live in a long-term care facility' && 
    medical_facility=='They plan to work in a hospital or other facility in the next 14 days' && no_medical_close_contact==undefined && no_equipment==undefined;

/******************/

  var contact_work = no_symptoms_sym =='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They don’t live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact=='Yes' && no_equipment=='No';

  var contact_work2 = no_symptoms_sym=='None of the above' && no_noneofabove=='I do not have any of these' && traveled=='They have not traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact=='No' && no_equipment==undefined;

  var contact_work3 = no_symptoms_sym=='None of the above' && no_noneofabove=='I do not have any of these' && traveled=='They have not traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact=='Yes' && no_equipment=='No';


/******************/
  var self_quarantine = no_symptoms_sym =='None of the above' && apply_selector != 'I do not have any of these' && traveled=='They have traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact=='Yes' && no_equipment=='Yes';

  var self_quarantine2 = no_symptoms_sym=='None of the above' && no_noneofabove=='I do not have any of these' && traveled=='They have not traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They don’t live in a long-term care facility' && 
    no_donnotknow_med=='They don’t work or plan to work in a medical facility' && no_medical_close_contact==undefined && no_equipment==undefined;

  var self_quarantine3 = no_symptoms_sym=='None of the above' && no_noneofabove=='I do not have any of these' && traveled=='They have not traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    no_donnotknow_med=='They don’t work or plan to work in a medical facility' && no_medical_close_contact==undefined && no_equipment==undefined;

  var self_quarantine4 = no_symptoms_sym=='None of the above' && (apply_len <= 9 && apply_len != 0) && traveled=='They have traveled internationally' && 
    no_exposure=='They’ve had close contact with someone who has COVID‑19' && no_care_facility=='They live in a long-term care facility' && 
    medical_facility=='They have worked in a hospital or other facility in the past 14 days' && no_medical_close_contact=='Yes' && no_equipment=='Yes';

/******************/

  var all_none_opt = no_symptoms_sym=='None of the above' && no_noneofabove == 'I do not have any of these' && 
    traveled=='They have not traveled internationally' && no_donnotknow=='They don’t know' &&
    no_care_facility=='They don’t live in a long-term care facility' && 
    no_donnotknow_med=='They don’t work or plan to work in a medical facility';

  var all_none_opt2 = no_symptoms_sym =='None of the above' && no_noneofabove == 'I do not have any of these' && 
    traveled=='They have not traveled internationally' && no_exposure=='They’ve had close contact with someone who has COVID‑19' && 
    no_care_facility=='They don’t live in a long-term care facility' && medical_facility=='They have worked in a hospital or other facility in the past 14 days' && 
    no_medical_close_contact=='Yes' && no_equipment=='Yes';

/*****************************/

  if( all_none_opt ){
      jQuery('.mess-alert').css('display', 'block');
  }else if( all_none_opt2 ){
      jQuery('.mess-alert').css('display', 'block');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_05').css('display', 'block');
  }else if( step_1to6_1 || step_1to6_2 || step_1to6_3 || step_1to6_4 || step_1to6_5 || step_1to6_6 || step_1to6_7 || step_1to6_8 || 
    step_1to6_9 || step_1to6_10 || step_1to6_11 ){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_02').css('display', 'block');
  }else if( health_provider || health_provider3 || health_provider5 || health_provider9 || health_provider11 || health_provider12 ){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_03').css('display', 'block');
  }else if( health_provider2 || health_provider4 || health_provider6 || health_provider7 || health_provider8 || health_provider10 ){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_03 .top-title.before.bg-none h2').text('Contact A Healthcare Provider');
      jQuery('.result_03 .top-title.before.bg-none p').text('Based on '+changing_text+' answers, '+changing_text2+' should talk to a doctor or a medical professional about '+changing_text+' current symptoms.');
      jQuery('.result_03').css('display', 'block');
  }else if( contact_work || contact_work2 || contact_work3 ){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_06').css('display', 'block');
  }else if( self_quarantine ){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_04').css('display', 'block');
  }else if( self_quarantine2 ){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_04_07').css('display', 'block');
  }else if( self_quarantine3 || self_quarantine4 ){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_04_08').css('display', 'block');
  }else{
    if(no_care_facility=='They live in a long-term care facility'){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_02').css('display', 'block');
    }else if(no_care_facility=='They don’t live in a long-term care facility' && no_donnotknow_med=='They don’t work or plan to work in a medical facility' ){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_03 .top-title.before.bg-none h2').text('Contact A Healthcare Provider');
      jQuery('.result_03 .top-title.before.bg-none p').text('Based on '+changing_text+' answers, '+changing_text2+' should talk to a doctor or a medical professional about '+changing_text+' current symptoms.');
      jQuery('.result_03').css('display', 'block');
    }else if(no_care_facility=='They don’t live in a long-term care facility' && (medical_facility=='They have worked in a hospital or other facility in the past 14 days' || medical_facility=='They plan to work in a hospital or other facility in the next 14 days') ){
      jQuery('.mess-alert').css('display', 'none');
      jQuery('.flex-column.full_row.full-clear').css('display', 'none');
      jQuery('.result_03').css('display', 'block');
    }
    
    jQuery('.mess-alert').css('display', 'none');
  }
}

/*****************************/

jQuery(document).on('click', '.share_step_screen', function(){
  if(jQuery('.labeled-dropdown-select').val()){
    jQuery(this).parents('.flex-column').css('display', 'none');
    jQuery(this).parents('.flex-column').addClass('selection');
    jQuery('.flex-column.full_row.full-clear.result').animate( { "opacity": "show", top:"0"} , 500 );
    jQuery('.final_responses').html(resopnsesList('notskip', 'share'));
    jQuery('.current_time').text(getCurrentDate());
  }else{
    jQuery(this).parents('.flex-column').css('display', 'none');
    jQuery(this).parents('.flex-column').addClass('selection');
    jQuery('.flex-column.full_row.full-clear.result').animate( { "opacity": "show", top:"0"} , 500 );
    jQuery('.final_responses').html(resopnsesList('skip', 'share'));
    jQuery('.current_time').text(getCurrentDate());
  }
  showNextSteps();
});

jQuery(document).on('click', '.not_step_screen', function(){
  if(jQuery('.labeled-dropdown-select').val()){
    jQuery(this).parents('.flex-column').css('display', 'none');
    jQuery(this).parents('.flex-column').addClass('selection');
    jQuery('.flex-column.full_row.full-clear.result').animate( { "opacity": "show", top:"0"} , 500 );
    jQuery('.final_responses').html(resopnsesList('notskip'));
    jQuery('.current_time').text(getCurrentDate());
  }else{
    jQuery(this).parents('.flex-column').css('display', 'none');
    jQuery(this).parents('.flex-column').addClass('selection');
    jQuery('.flex-column.full_row.full-clear.result').animate( { "opacity": "show", top:"0"} , 500 );
    jQuery('.final_responses').html(resopnsesList('skip'));
    jQuery('.current_time').text(getCurrentDate());
  }
  showNextSteps();
});


jQuery(document).on('click', '.last_next_step', function(){
  if(jQuery('.labeled-dropdown-select').val() && jQuery('#second_step_screening').val()=="Use For Someone Else"){
    jQuery('.last_next_step').parents('.flex-column').css('display', 'none');
    jQuery('.last_next_step').parents('.flex-column').nextAll('.result:first').animate( { "opacity": "show", top:"0"} , 500 );
    jQuery('.final_responses').html(resopnsesList('notskip'));
    jQuery('.current_time').text(getCurrentDate());
    showNextSteps();
  }else if(jQuery('#second_step_screening').val()=="Use For Myself" && jQuery('.labeled-dropdown-select').val()){
    jQuery(this).parents('.flex-column').css('display', 'none');
    jQuery('.selection-share').animate( { "opacity": "show", top:"0"} , 500 );
    jQuery('.final_responses').html(resopnsesList('notskip'));
    jQuery('.current_time').text(getCurrentDate());
    // showNextSteps();
  }
  jQuery('html,body').animate({
      scrollTop: jQuery('.page-container-content').offset().top-90
  }, 'slow');
});

jQuery(document).on('click', '.medical_facility_step_cond', function(){
  var medical_facility = jQuery('input[name="medical_facility"]:checked').val();
  var donnotknow_med = jQuery('input[name="donnotknow_med"]:checked').val();
  if(medical_facility!=undefined || donnotknow_med != undefined){
    if(jQuery('#check-22:checked').val()!=undefined && medical_facility=='They have worked in a hospital or other facility in the past 14 days'){ 
      jQuery('.medical_facility').addClass('selection');
      jQuery('.equipment').addClass('selection');
      jQuery(this).parents('.flex-column').css('display', 'none');
      jQuery(this).parents('.flex-column').next('.medical_facility').animate( { "opacity": "show", top:"0"} , 500 );
    }else{
      jQuery('input[name="medical_close_contact"]').prop('checked', false);
      jQuery('input[name="equipment"]').prop('checked', false);
      jQuery('.equipment').removeClass('selection');
      jQuery('.medical_facility').removeClass('selection');
      jQuery(this).parents('.flex-column').css('display', 'none');
      jQuery(this).parents('.flex-column').nextAll('.skip_medical_equipment').animate( { "opacity": "show", top:"0"} , 500 );
    }
    jQuery('html,body').animate({
        scrollTop: jQuery('.page-container-content').offset().top-90
    }, 'slow');
  }else{
    return false
  }
});

jQuery(document).on('click', '.have_covid_step', function(){
  var medical_facility = jQuery('input[name="medical_close_contact"]:checked').val();
  if(medical_facility!=undefined){
    if(medical_facility!=undefined && medical_facility=='Yes'){
      jQuery('.equipment').addClass('selection');
      jQuery(this).parents('.flex-column').css('display', 'none');
      jQuery(this).parents('.flex-column').next('.equipment').animate( { "opacity": "show", top:"0"} , 500 );
    }else{
      jQuery('input[name="equipment"]').prop('checked', false);
      jQuery('.equipment').removeClass('selection');
      jQuery(this).parents('.flex-column').css('display', 'none');
      jQuery(this).parents('.flex-column').nextAll('.skip_medical_equipment').animate( { "opacity": "show", top:"0"} , 500 );
    }
  }else{
    return false;
  }
});


jQuery(document).on('click', '.third_step_screen', function(){
  var selection = jQuery(this).parents('.detail').find('input[type="radio"]:checked').val();
  var selection_check = jQuery(this).parents('.detail').find('input[type="checkbox"]:checkbox:checked').val();
  if(selection!=undefined || selection_check!=undefined){
    if(selection != 'I’m experiencing at least one of these' && selection != 'Under 18' && selection != 'Between 18 and 64' 
       && selection != '65 or older'){
      jQuery(this).parents('.flex-column').css('display', 'none');
      jQuery(this).parents('.flex-column').next('.selection').animate( { "opacity": "show", top:"0"} , 500 );
    }else if(selection == 'Under 18'){
      jQuery(this).parents('.flex-column').css('display', 'none');
      jQuery(this).parents('.flex-column').next('.under-18').animate( { "opacity": "show", top:"0"} , 500 );
    }else if(selection == 'Between 18 and 64' || selection == '65 or older'){
      jQuery(this).parents('.flex-column').css('display', 'none');
      jQuery(this).parents('.flex-column').nextAll('.bet-1864').animate( { "opacity": "show", top:"0"} , 500 );
    }
    jQuery('html,body').animate({
        scrollTop: jQuery('.page-container-content').offset().top
    }, 'slow');
  }else{
    return false;
  }
});


jQuery(document).on('click', '.go_onestepback', function(){
  jQuery(this).parents('.flex-column').css('display', 'none');
  jQuery(this).parents('.flex-column').prevAll('.selection:first').animate( { "opacity": "show", top:"0"} , 500 );
  /*if(jQuery('.equipment').hasClass('selection')){
    jQuery('.equipment').removeClass('selection');
    jQuery('.medical_facility').removeClass('selection');
  }*/
});

jQuery(document).on('click', '.go_onestepback_emer', function(){
  jQuery('.screening_tabs').css('display', 'none');
  jQuery('#screening_step_2').animate( { "opacity": "show", top:"0"} , 500 );
});

jQuery(document).on('click', '.skip_state_step', function(){
  jQuery('.labeled-dropdown-select').val('');
  if(jQuery('#second_step_screening').val()=='Use For Myself'){
    jQuery(this).parents('.flex-column').css('display', 'none');
    jQuery(this).parents('.flex-column').next('.selection-share').animate( { "opacity": "show", top:"0"} , 500 );
  }else{
    jQuery(this).parents('.flex-column').css('display', 'none');
    jQuery(this).parents('.flex-column').nextAll('.result:last').animate( { "opacity": "show", top:"0"} , 500 );
    showNextSteps();
  }
  jQuery('.final_responses').html(resopnsesList('skip'));
  jQuery('.current_time').text(getCurrentDate());

  jQuery('html,body').animate({
      scrollTop: jQuery('.page-container-content').offset().top
  }, 'slow');
});


jQuery(document).on('change', 'input[name="exposure_no_expos"]', function(){
    jQuery('input[name="donnotknow"]').prop('checked', false);
    jQuery('input[name="exposure"]').prop('checked', false);
});

jQuery(document).on('change', 'input[name="exposure"]', function(){
    jQuery('input[name="donnotknow"]').prop('checked', false);
    jQuery('input[name="exposure_no_expos"]').prop('checked', false);
});

jQuery(document).on('change', 'input[name="donnotknow"]', function(){
    jQuery('input[name="exposure"]').prop('checked', false);
    jQuery('input[name="exposure_no_expos"]').prop('checked', false);
});

jQuery(document).on('change', 'input[name="donnotknow_med"]', function(){
    jQuery('input[name="medical_facility"]').prop('checked', false);
});

jQuery(document).on('change', 'input[name="medical_facility"]', function(){
    jQuery('input[name="donnotknow_med"]').prop('checked', false);
});

jQuery(document).on('change', 'input[name="noneofabove"]', function(){
    jQuery('input[name="selector"]').prop('checked', false);
});

jQuery(document).on('change', 'input[name="selector"]', function(){
    jQuery('input[name="noneofabove"]').prop('checked', false);
});

jQuery(document).on('change', 'input[name="symptoms_sym"]', function(){
    jQuery('input[name="symptoms"]').prop('checked', false);
});

jQuery(document).on('change', 'input[name="symptoms"]', function(){
    jQuery('input[name="symptoms_sym"]').prop('checked', false);
});

jQuery(document).on('click', '.close-popup', function(){
  jQuery (".about-sharing-popup").hide();
});

jQuery(document).on('click', '.about-sharing-popup-open', function(){
  jQuery (".about-sharing-popup").show();
  jQuery('html,body').animate({
    scrollTop: jQuery("#PageContainer").offset().top
  }, 'slow');
});

jQuery(document).on('click', '.see-term-popup', function(){
  jQuery (".about-sharing-popup").show();
  jQuery('html,body').animate({
    scrollTop: jQuery("#PageContainer").offset().top
  }, 'slow');
});